// @flow
/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/common-utils';
import {
  Button,
  Confirmation,
  GridLayout,
  Text,
} from '@zapier/common-components';

type Props = {
  isShared: boolean,
  unshareMessage: string,
  shareMessage: string,
  onToggleIsShared: () => void,
};

const ShareToggle = (props: Props) => {
  return (
    <Confirmation onConfirm={props.onToggleIsShared} shouldTimeOut={false}>
      {
        // $FlowFixMe
        ({ isConfirming, onClick }) => (
          <GridLayout
            alignItems="center"
            columns="1fr 4fr"
            gap={20}
            propsQueries={{
              phoneOnly: {
                columns: null,
                rows: '1fr 1fr',
              },
            }}
          >
            <Button
              backgroundType={
                !props.isShared || isConfirming ? null : 'chameleon'
              }
              color={isConfirming || props.isShared ? 'important' : 'primary'}
              onClick={onClick}
            >
              {isConfirming
                ? 'Are you sure?'
                : props.isShared
                ? 'Make Private'
                : 'Share'}
            </Button>
            {isConfirming && (
              <Text color="batmobile" type="body">
                {props.isShared ? props.unshareMessage : props.shareMessage}
              </Text>
            )}
          </GridLayout>
        )
      }
    </Confirmation>
  );
};

export default ShareToggle;
